import { RNG } from "rot-js";
import { WorldTile } from "../../../engine/map/LevelMap";
import { Bounds } from "../../../engine/space/bounds";
import { FloorTypes } from "../Map";
import { BasicMap } from "../BasicMap";
import { forEachShared, oneRandomShared } from "./roomHelpers";

export const fillEdges = (map: BasicMap) => {
  const botRow = map.height - 1;
  const oneMinusBot = map.height - 2;
  const right = map.width - 1;
  const oneMinusRight = map.width - 2;

  for (let x = 0; x < map.width; x++) {
    map.tileAt(x, 0).type = FloorTypes.WALL;
    map.tileAt(x, oneMinusBot).type = FloorTypes.WALL;
    map.tileAt(x, botRow).type = FloorTypes.WALL;
    map.tileAt(x, botRow).type = FloorTypes.WALL;
  }

  for (let y = 0; y < map.height; y++) {
    map.tileAt(0, y).type = FloorTypes.WALL;
    map.tileAt(oneMinusRight, y).type = FloorTypes.WALL;
    map.tileAt(right, y).type = FloorTypes.WALL;
    map.tileAt(right, y).type = FloorTypes.WALL;
  }
};

export const obstacleShared = (map: BasicMap, a: Bounds, b: Bounds) => {
  forEachShared(
    map,
    a,
    b,
    (tile: WorldTile<FloorTypes>, neighbor: WorldTile<FloorTypes>) => {
      tile.type = FloorTypes.WALL;
      neighbor.type = FloorTypes.WALL;
    }
  );
};

export const carveShared = (map: BasicMap, a: Bounds, b: Bounds) => {
  forEachShared(
    map,
    a,
    b,
    (tile: WorldTile<FloorTypes>, neighbor: WorldTile<FloorTypes>) => {
      tile.type = FloorTypes.EMPTY;
      neighbor.type = FloorTypes.EMPTY;
    }
  );
};

export const makeDoor = (
  rng: typeof RNG,
  map: BasicMap,
  a: Bounds,
  b: Bounds
) => {
  oneRandomShared(map, rng, a, b, (tile, neighbor) => {
    tile.type = FloorTypes.EMPTY;
    neighbor.type = FloorTypes.EMPTY;
  });
};
